/**
 *
 * @module paymentMethodType
 * @see https://github.com/STRML/keyMirror
 *
 */

/* eslint new-cap: 'off' */

import KeyMirror from 'keymirror';

/**
 *
 * @typedef PaymentMethodType
 * @type {Object}
 * @desc An enumeration of recognized payment methods.
 * @note These values are returned from the service in PascalCase
 *
 * @property {String} PaymentCard
 * @property {String} Other
 *
 */

/**
*
* @enum
* @type {PaymentMethodType}
*
*/
export default KeyMirror({
    /**
     *
     * @access public
     * @type {String}
     *
     */
    PaymentCard: null,
    /**
     *
     * @access public
     * @type {String}
     *
     */
    Other: null
});



// WEBPACK FOOTER //
// ./src/services/commerce/paymentMethodType.js